import React from 'react';
import ManagedInput from 'components/form/managed_input';
import { Panel } from 'react-bootstrap';

type PermissionCardProps = {
  checked: boolean;
  label: string;
  name?: string;
  subtitle?: string;
  onClick: () => void;
};

const PermissionCard = ({ checked, label, subtitle = '', name = '', onClick } : PermissionCardProps) => {
  return (
    <Panel className="permission-block">
      <Panel.Body>
        <label className="d-flex form-group boolean align-items-start gap-3 fw-normal">
          <input
            checked={checked}
            name={name}
            type="radio"
            onChange={onClick}
          />
          <div className="clickable">
            <div>{label}</div>
            <div className="help-block mb-0">{subtitle}</div>
          </div>
        </label>        
      </Panel.Body>
    </Panel>
  );
};
export default PermissionCard;
